var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgMultipleExchanges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 117,
    viewBox: "0 0 124 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.6562,
    y: 28.6064,
    width: 64,
    height: 64,
    rx: 16,
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7795 64.1689H88.6842L95.8559 69.7997L71.7795 92.8362L47.7031 69.7997L62.815 64.6807L71.7795 64.1689Z",
    fill: "url(#paint0_linear_734_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7796 92.8342L57.436 75.4297H86.1228L71.7796 92.8342Z",
    fill: "url(#paint1_linear_734_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1228 75.43L95.8559 69.7992L71.7795 46.7627L47.7031 69.7992L57.4362 75.43H86.1228Z",
    fill: "url(#paint2_linear_734_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7798 46.7646L86.1231 75.4309H57.4365L71.7798 46.7646Z",
    fill: "url(#paint3_linear_734_1042)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_734_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9348 60.1773C21.9348 60.1773 13.0045 92.7577 43.2363 111.753C68.8023 127.817 94.6228 94.8246 75.4021 77.9985C62.2327 66.4705 61.8894 57.8444 61.0531 46.5967C59.7264 28.7547 32.391 20.478 21.9348 60.1773Z",
    fill: "url(#paint4_radial_734_1042)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_734_1042",
    x: -1.29688,
    y: 9.7627,
    width: 105.382,
    height: 128.282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_734_1042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_1042",
    x1: 85.0985,
    y1: 64.1689,
    x2: 85.0985,
    y2: 100.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA17DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_734_1042",
    x1: 71.7796,
    y1: 100.513,
    x2: 71.7796,
    y2: 75.4297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA17DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_734_1042",
    x1: 58.2684,
    y1: 85.1561,
    x2: 58.2684,
    y2: 39.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_734_1042",
    x1: 71.5609,
    y1: 39.0862,
    x2: 71.5609,
    y2: 75.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_734_1042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8597 50.4773) rotate(92.6593) scale(58.1852 51.9563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF7EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 116,
    fill: "white",
    transform: "translate(0 0.106445)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMultipleExchanges);
export default __webpack_public_path__ + "static/media/img-multiple-exchanges.5300be62f6313fdcf238fd06f0ea96e4.svg";
export { ForwardRef as ReactComponent };